// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTable_wrapper__2LR_M","tableContainer":"DataTable_tableContainer__1y-pl","table":"DataTable_table__3De4Z","paginationWrapper":"DataTable_paginationWrapper__fN9vx"};